import { Card } from "antd";
import { useState } from "react";
import { PageSizes } from "../../../../../common/constants";
import { CommissionOriginType, CommissionProcessingResult } from "../../enums";
import { CommissionsBatch, CommissionsFilterPageRequest } from "../../types";
import { BatchCalculatedCommissionFilterForm } from "../forms/filter/BatchCalculatedCommissionFilterForm";
import { BatchCommissionsTable } from "../tables/BatchCommissionsTable";

interface Props {
  batch: CommissionsBatch;
}

const pageSize = PageSizes.HUGE;

export const CommissionsBatchCalculationStep = ({ batch }: Props) => {
  const [commissionFilterPageRequestData, setCommissionFilterPageRequestData] = useState<CommissionsFilterPageRequest>({
    pageIndex: 0,
    pageSize: pageSize,
    keyword: undefined,
    origin: CommissionOriginType.ALL,
    processingResult: CommissionProcessingResult.ALL,
    postponementReasons: [],
    institutionIds: [],
  });

  return (
    <Card className="card-box">
      <BatchCalculatedCommissionFilterForm
        step={batch.step}
        showCalculationFilterOptions
        onFilterSubmit={(filter) => setCommissionFilterPageRequestData({ ...filter, pageIndex: 0 })}
        filterPageSize={pageSize}
      />

      <BatchCommissionsTable
        batch={batch}
        viewType="calculated"
        filterData={commissionFilterPageRequestData}
        onPageChange={(pageIndex) =>
          setCommissionFilterPageRequestData({ ...commissionFilterPageRequestData, pageIndex: pageIndex - 1 })
        }
      />
    </Card>
  );
};
